import React from 'react';
import {
  Center,
  ConditioningIcon,
  CourageousIcon,
  CuriousIcon,
  DiscerningIcon,
  NourishingIcon,
  ResultsIcon,
  Stack,
  Text,
} from '../../components';

export const coreValuesData = [
  {
    icon: <NourishingIcon />,
    title: 'Be Human',
    description:
      'We talk with, not at, our community and each other. We lead with honesty and kindness, take ownership, and choose trust over ego.',
  },
  {
    icon: <CuriousIcon />,
    title: 'Be Curious',
    description:
      'Curiosity drives us, and taste guides us. We ask questions, take thoughtful risks, and reimagine what’s possible.',
  },
  {
    icon: <DiscerningIcon />,
    title: 'Be Playful',
    description:
      'Play strengthens connection and sparks ideas. We create space to bring our full selves to work and find joy in creating together.',
  },
  {
    icon: <ConditioningIcon />,
    title: 'Be Helpful',
    description:
      'We look for ways to be useful to each other, and to our community. We focus on what helps, act on it, and make things clearer and easier for the people around us.',
  },
];

export const CoreValuesComponent = (props) => {
  let { coreValue, align } = props;
  let { icon, title, description } = coreValue || {
    icon: '',
    title: '',
    description: '',
  };
  return (
    <Stack size={4}>
      {align === 'left' ? icon : <Center>{icon}</Center>}
      <Text align={align} textType="primary1">
        {title}
      </Text>
      <Text align={align} textType="primary2">
        {description}
      </Text>
    </Stack>
  );
};
